module.exports = __webpack_public_path__ + "img/36.dc19d10c.png";